import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentRequestTask } from '../shared/_generated/backend';

@Component({
    selector: 'details-dialog',
    styleUrl: 'details-dialog.component.scss',
    templateUrl: 'details-dialog.component.html',
    standalone: false
})
export class DetailsDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<DetailsDialogComponent, 'yes'>,
        @Inject(MAT_DIALOG_DATA) public data: PaymentRequestTask
    ) { }
}
